module.exports = __webpack_public_path__ + "img/share@3x.4a20c2f2.png";